"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAccordionTitleContainer = exports.StyledAccordionItemContainer = exports.ItemContentContainer = exports.StyledDescriptionContainer = exports.StyledAccordion = exports.StyledAccordionContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        transform: rotate(-180deg);\n\n        path {\n          fill: ", ";\n        }\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 0 1rem;\n  cursor: pointer;\n  box-sizing: inherit;\n\n  & > span,\n  & > p {\n    max-width: 263px;\n    font-size: 1.4375rem;\n    line-height: 1.73125rem;\n\n    ", ";\n\n    @media screen and (min-width: ", ") {\n      max-width: 361px;\n    }\n\n    @media screen and (min-width: ", ") {\n      max-width: 705px;\n    }\n  }\n\n  &:hover {\n    & > span,\n    & > p {\n      color: ", ";\n    }\n\n    & > svg {\n      path {\n        fill: ", ";\n      }\n    }\n  }\n\n  & > svg {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    transition: transform 0.25s ease-in-out;\n\n    ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      height: calc(3.875rem + ", "px);\n\n      @media screen and (min-width: ", ") {\n        height: calc(4rem + ", "px);\n      }\n\n      @media screen and (min-width: ", ") {\n        height: calc(4.9375rem + ", "px);\n      }\n\n      @media screen and (min-width: ", ") {\n        height: calc(5.25rem + ", "px);\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: ", ";\n  padding: 0 0rem 0rem 0.875rem;\n  overflow: hidden;\n  transition: height 0.25s ease-in-out;\n  box-sizing: inherit;\n\n  @media screen and (min-width: ", ") {\n    padding: 0 1.81rem 0rem 0.75rem;\n  }\n\n  @media screen and (min-width: ", ") {\n    padding: 0 1.875rem 0rem 1.25rem;\n  }\n\n  ", ";\n\n  ", "\n\n  & svg {\n    margin-right: 1rem;\n  }\n\n  & ul {\n    padding-right: 0;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    padding-bottom: 27px;\n    border: none;\n    box-sizing: inherit;\n    ", "\n\n    @media screen and (min-width: ", ") {\n        padding-bottom: 1.375rem;\n    }\n\n    @media screen and (min-width: ", ") {\n        padding-bottom: 1.1875rem;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  box-sizing: inherit;\n\n  @media screen and (min-width: ", ") {\n    max-width: 558px;\n  }\n\n  @media screen and (min-width: ", ") {\n    max-width: 1020px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  box-sizing: border-box;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 2px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var bottomBorder = function bottomBorder(props) {
  return (0, _styledComponents.css)(_templateObject(), props.theme.colors.brandThemeLight100);
};

var StyledAccordionContainer = _styledComponents.default.div(_templateObject2());

exports.StyledAccordionContainer = StyledAccordionContainer;

var StyledAccordion = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.lg;
}); // CONTAINER FOR THE ACCORDION DESCRIPTION


exports.StyledAccordion = StyledAccordion;

var StyledDescriptionContainer = _styledComponents.default.div(_templateObject4(), function (props) {
  return bottomBorder(props);
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.lg;
});

exports.StyledDescriptionContainer = StyledDescriptionContainer;

var ItemContentContainer = _styledComponents.default.div(_templateObject5()); // CONTAINER FOR EACH ACCORDION ITEM


exports.ItemContentContainer = ItemContentContainer;

var StyledAccordionItemContainer = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.height ? "".concat(props.height, "px") : 'auto';
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.lg;
}, function (props) {
  return props.isSelected && (0, _styledComponents.css)(_templateObject7(), props.height, props.theme.breakpoints.sm, props.height, props.theme.breakpoints.lg, props.height, props.theme.breakpoints.xl, props.height);
}, function (props) {
  return bottomBorder(props);
}); // ACCORDION ITEM TITLE


exports.StyledAccordionItemContainer = StyledAccordionItemContainer;

var StyledAccordionTitleContainer = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.isSelected && (0, _styledComponents.css)(_templateObject9(), props.theme.colors.actionPrimary300);
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.breakpoints.lg;
}, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.theme.colors.actionPrimary300;
}, function (props) {
  return props.isSelected && (0, _styledComponents.css)(_templateObject10(), props.theme.colors.actionPrimary300);
});

exports.StyledAccordionTitleContainer = StyledAccordionTitleContainer;